module.exports = __webpack_public_path__ + "static/toolspage-f6008840cf1e0cfbd252f5c80830eff6.png";